module.exports = __webpack_public_path__ + "static/media/PrincessUnlimited.19f8ad45.jpg";